import { render, staticRenderFns } from "./StudentGeneralInformation.vue?vue&type=template&id=753a43bd&scoped=true"
import script from "./StudentGeneralInformation.vue?vue&type=script&lang=js"
export * from "./StudentGeneralInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753a43bd",
  null
  
)

export default component.exports